"use client";

import { formatPhoneInput } from "@/lib/phone";

export default function PhoneInput({
  value,
  onChange,
  style,
  placeholder = "(555) 555-5555",
  autoFocus,
}: {
  value: string;
  onChange: (val: string) => void;
  style?: React.CSSProperties;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  return (
    <input
      type="tel"
      value={value}
      onChange={e => onChange(formatPhoneInput(e.target.value))}
      placeholder={placeholder}
      maxLength={14}
      style={style}
      autoFocus={autoFocus}
    />
  );
}
